export const LOCALES = [
  {
    id: 'en',
    name: 'English',
  },
  {
    id: 'es',
    name: 'Español',
  },
  {
    id: 'pt',
    name: 'Português',
  },
];
